import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';

// The wildcard route: rendered inside PrivateRoute, so the header and its page
// links are present and the user is one click from anywhere real.
export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4">Page not found</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 520, wordBreak: 'break-word' }}>
        There is no Decode page at <code>{pathname}</code>. It may have moved, or the address may have been mistyped.
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ mt: 1 }}>
        <Button component={RouterLink} to="/" variant="contained" sx={{ textTransform: 'none' }}>Dashboard</Button>
        <Button component={RouterLink} to="/data" variant="outlined" sx={{ textTransform: 'none' }}>Data</Button>
        <Button component={RouterLink} to="/agent" variant="outlined" sx={{ textTransform: 'none' }}>Decode Agent</Button>
      </Stack>
    </Box>
  );
}
